import React from 'react';

type Props = {
  message: string;
};

const FormGeneralError: React.FC<Props> = ({ message }) => {
  return (
    <div className="FormError">
      <div className="ErrorMessage">{message}</div>
    </div>
  );
};

export default FormGeneralError;
